var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-md btn-block btn-outline-info waves-effect waves-themed",
          on: {
            click: function ($event) {
              return _vm.add_prod()
            },
          },
        },
        [
          _c("span", { staticClass: "fal fa-eject mr-1" }),
          _vm._v(
            "\n            " + _vm._s(_vm.__t("ADD_PAYMENT")) + "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.payments.length > 0
      ? _c("div", { staticClass: "border bg-light rounded-top" }, [
          _c(
            "div",
            {
              staticClass:
                "accordion accordion-hover accordion-clean js-list-filter",
              attrs: { id: "js_list_accordion" },
            },
            _vm._l(_vm.payments, function (payment) {
              return _c(
                "div",
                {
                  staticClass:
                    "card border-top-left-radius-0 border-top-right-radius-0",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      on: {
                        click: function ($event) {
                          return _vm.edit_type(payment)
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "card-title collapsed pt-2 pb-2",
                          attrs: { href: "javascript:void(0);" },
                        },
                        [
                          _c("i", { staticClass: "fa fa-fog pr-4" }),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(payment.title) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "small badge border border-success",
                              },
                              [
                                _vm._v(
                                  "\n                                POS_ID: " +
                                    _vm._s(payment.uniq_id) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }